import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './css/notifications.css'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom'

/**
 * Production assets live under `/search/`, but the SPA may be served at `/` (e.g. Docker nginx
 * `try_files` on `/`). Only set basename when the URL is actually under that prefix so `/` does
 * not get "corrected" away from the dev port or the container root.
 */
function getRouterBasename(): string | undefined {
  const raw = import.meta.env.BASE_URL || '/'
  if (raw === '/') return undefined
  const base = raw.replace(/\/$/, '')
  if (typeof window === 'undefined') return undefined
  const { pathname } = window.location
  if (pathname === base || pathname.startsWith(`${base}/`)) return base
  return undefined
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={getRouterBasename()}>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
